/**
 * @import internal modules
 */
import InputTextGrid from '@apps-widgets/input-text/component';
import BtnTextGrid from '@apps-widgets/input-bouton/component';
// import InputCheckboxGrid  from "@apps-widgets/input-checkbox/component";

/**
 * @import external modules
 */

import * as React from 'react';
import { pure } from 'recompose';
// import * as shortid from 'shortid';
import * as cx from 'classnames';

// component
const Component: React.FunctionComponent<any> = (
    props: InterfaceAuthentification<string, boolean>,
): JSX.Element => {
    const {
        classnames,
        onChange,
        emptyError,
        onLogin /*onChangeRadio ,onLogin, checked*/,
    } = props;

    const [authentificationArray] = React.useState<object[]>([
        { type: 'text', placeholder: 'Identifiant', name: 'identifiant' },
        { type: 'password', placeholder: 'Mot de passe', name: 'password' },
    ]);

    return (
        <div className={classnames}>
            <div className="authente-box">
                <div className="box-form title-box-form">
                    <h3 className="animated-demo-text">Demo </h3>
                    <h3 className="logo-name-apps">tollsense</h3>
                </div>

                <div className="login-infos">
                    {authentificationArray.map((Elem: any, index: number) => {
                        return (
                            <div className="box-form" key={index}>
                                <InputTextGrid
                                    emptyError={emptyError}
                                    type={Elem.type}
                                    placeholder={Elem.placeholder}
                                    className={cx('input-text', {
                                        emptyError,
                                    })}
                                    onChange={onChange}
                                    name={`${Elem.name}`}
                                    id={`${Elem.name}-`}
                                />
                            </div>
                        );
                    })}

                    <div className="box-form ">
                        <div className="box-short-btn">
                            {' '}
                            <BtnTextGrid
                                className="btn-text"
                                OnClick={onLogin}
                                id="eudMITH"
                                text="Se connecter"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// interface
export interface InterfaceAuthentification<T, B> {
    classnames: T;
    success: B;
    faillure: B;
    name?: T;
    emptyError?: boolean;
    checked?: any;
    onChange: any;
    onChangeRadio: any;
    onLogin: any;
}
/**
 * DefaultProps values
 */
Component.defaultProps = {};

export default pure(Component);



// WEBPACK FOOTER //
// ./src/apps/components/@widgets/authentification/component.tsx